module.exports = __webpack_public_path__ + "img/starname-light.3aa119b7.svg";